<div class="cart-table-container">
  <div class="container-header">
    DONATIONS HISTORY
  </div>

  <table mat-table [dataSource]="donationsTable">
    <ng-container matColumnDef="id">
      <th class="header-bg" mat-header-cell *matHeaderCellDef>
        DONATION ID
      </th>
      <td mat-cell *matCellDef="let line">
        <div  class="id-text cell-content">{{ line._id }}</div>
      </td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th class="header-bg" mat-header-cell *matHeaderCellDef>Date</th>
      <td mat-cell *matCellDef="let line">
        <div  class="cell-content">{{ line.timestamp | date:'medium' }}</div>
      </td>
    </ng-container>

    <ng-container matColumnDef="category">
      <th class="header-bg" mat-header-cell *matHeaderCellDef>Category</th>
      <td mat-cell *matCellDef="let line">
        <div  class="cell-content">{{ line.category }}</div>
      </td>
    </ng-container>

    <ng-container matColumnDef="frequency">
      <th class="header-bg" mat-header-cell *matHeaderCellDef>Frequency</th>
      <td mat-cell *matCellDef="let line">
        <div  class="cell-content">{{ line.type === 'ONE_TIME' ? 'ONE TIME' : line.frequency }}</div>
      </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th class="header-bg" mat-header-cell *matHeaderCellDef>Amount</th>
      <td mat-cell *matCellDef="let line">
        <div  class="cell-content">{{ line.amountPayed | amount | currency }}</div>
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th class="header-bg" mat-header-cell *matHeaderCellDef>Details<th>
      <td mat-cell *matCellDef="let line">
        @if(line.type === 'ONGOING') {
          <button mat-button (click)="manageSubscription(line)" color="primary" class="btn-details">
            Subscription Details
            <mat-icon iconPositionEnd>settings</mat-icon>
          </button>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="receipt">
      <th class="header-bg" mat-header-cell *matHeaderCellDef>Transaction Details<th>
      <td mat-cell *matCellDef="let line">
        @if(line.type === 'ONGOING') {
          <button mat-button (click)="openReceiptDialogForOngoing(line)" color="primary" class="btn-details">
            Receipts
            <mat-icon iconPositionEnd>receipt_long</mat-icon>
          </button>
        } @else {
          <button mat-button (click)="openSimpleReceiptDialog(line.payments.at(0))" color="primary" class="btn-details">
            Receipt
            <mat-icon iconPositionEnd>receipt_long</mat-icon>
          </button>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator
    [length]="totalLines"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onPaginationChange($event)"
    showFirstLastButtons
    aria-label="Select page of donations"
  >
  </mat-paginator>
</div>
